import { EventName } from '../constants';
import { createAndSendEvent } from '../jumboClient';

export const LifelineLoginEvent = (properties = {}) =>
  createAndSendEvent(EventName.LIFELINE_LOGIN_BTN_CLICK_EVENT, properties);

export const LifelineLogoutEvent = (properties = {}) =>
  createAndSendEvent(EventName.LIFELINE_LOGOUT_BTN_CLICK_EVENT, properties);

export const LifelineAutoLogoutEvent = (properties = {}) =>
  createAndSendEvent(EventName.LIFELINE_AUTO_LOGOUT_TRIGGER_EVENT, properties);
